import {Button, Col, Modal, Row, Tag, Tooltip} from "antd";
import {
  StyledInfoItem,
  StyledModalContentWrapper,
} from "../../../styles/transactions/transactions";
import moment from "moment";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {Transaction} from "../../../features/transactions";

type TTransactionDetailsModalProps = {
  transaction: Transaction | null;
  visibleState: boolean;
  okFunc: () => void;
  cancelFunc: () => void;
  footerContent?: React.ReactNode[];
};

export function TransactionDetailsModal({
  transaction,
  cancelFunc,
  okFunc,
  visibleState,
}: TTransactionDetailsModalProps) {
  const modalProps = {
    title: "Transaction Details",
    visible: visibleState,
    onOk: okFunc,
    onCancel: cancelFunc,
    footer: null,
    width: "50%" as const,
    style: {
      height: "100vh",
      top: "0",
      right: "0",
      position: "absolute" as const,
      paddingBottom: "0px",
    },
    wrapClassName: "transactions-modal-content",
  };

  if (!transaction) {
    return (
      <Modal {...modalProps}>
        <StyledModalContentWrapper>
          <p style={{textAlign: "center", color: "#999"}}>
            Select a transaction to view details
          </p>
        </StyledModalContentWrapper>
      </Modal>
    );
  }

  return (
    <Modal {...modalProps}>
      <StyledModalContentWrapper>
        <div>
          {transaction.isPending() ? (
            <Tooltip
              placement="right"
              title="Pending conversions typically takes 3 to 4 days before they are added to your wallet"
            >
              <div style={{display: "flex", alignItems: "center"}}>
                <Tag color="warning">Pending conversion</Tag>
                <Button
                  style={{color: "#FAAD14"}}
                  icon={<QuestionCircleOutlined />}
                  size="small"
                  type="text"
                />
              </div>
            </Tooltip>
          ) : (
            <div style={{marginBottom: "1rem"}}>
              <Tag color="green">Completed</Tag>
            </div>
          )}
        </div>
        <Row gutter={[32, 20]} style={{marginBottom: "2rem"}}>
          <Col xs={24} md={12} className="left-side">
            <StyledInfoItem>
              <p className="info-title">Customer</p>
              <p className="info-value">{transaction.customerName}</p>
              <p className="info-value">{transaction.customerEmail}</p>
            </StyledInfoItem>
          </Col>
          <Col xs={24} md={12} className="right-side">
            <StyledInfoItem>
              <p className="info-title">Date</p>
              <p className="info-value">
                {moment(transaction.paymentDate).format("ddd, MMM DD YYYY")}
              </p>
            </StyledInfoItem>
          </Col>
        </Row>
        <Row gutter={[32, 20]} style={{marginBottom: "2rem"}}>
          <Col xs={24} md={12}>
            <StyledInfoItem>
              <p className="info-title">Transaction reference</p>
              <p className="info-value">{transaction.reference}</p>
            </StyledInfoItem>
          </Col>
        </Row>
        <hr style={{borderColor: "#D9D9D9"}} />

        {transaction.isForeign() ? (
          <table
            style={{
              width: "100%",
              borderSpacing: "0 12px",
              borderCollapse: "unset",
            }}
          >
            <tbody>
              <tr>
                <td
                  className="info-title"
                  style={{textAlign: "left", fontWeight: "bold"}}
                >
                  Amount
                </td>
                <td className="info-value" style={{textAlign: "right"}}>
                  {transaction.currency} {transaction.amount.toLocaleString()}
                </td>
              </tr>
              <tr>
                <td
                  className="info-title"
                  style={{textAlign: "left", fontWeight: "bold"}}
                >
                  Exchange rate
                </td>
                <td className="info-value" style={{textAlign: "right"}}>
                  {transaction.exchangeRate || "N/A"}
                </td>
              </tr>
              <tr>
                <td
                  className="info-title"
                  style={{textAlign: "left", fontWeight: "bold"}}
                >
                  Converted price
                </td>
                <td className="info-value" style={{textAlign: "right"}}>
                  {transaction.convertedPrice || "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <>
            <table
              style={{
                width: "100%",
                borderSpacing: "0 12px",
                borderCollapse: "unset",
              }}
            >
              <tbody>
                <tr>
                  <td
                    className="info-title"
                    style={{textAlign: "left", fontWeight: "bold"}}
                  >
                    Discount
                  </td>
                  <td className="info-value" style={{textAlign: "right"}}>
                    {transaction.currency} {transaction.discount.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td
                    className="info-title"
                    style={{textAlign: "left", fontWeight: "bold"}}
                  >
                    Transaction fee <br />
                    {transaction.chargeBearer && (
                      <span
                        style={{
                          color: " #722ed1",
                          backgroundColor: "#f9f0ff",
                          fontSize: "12px",
                          padding: "4px 8px",
                          border: "1px solid #D3ADF7",
                        }}
                      >
                        Paid by {transaction.chargeBearer}
                      </span>
                    )}
                  </td>
                  <td className="info-value" style={{textAlign: "right"}}>
                    -
                    {transaction.chargeBearer === "coach" && (
                      <>
                        {transaction.currency} {transaction.charges.toLocaleString()}
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{marginTop: "1rem", textAlign: "left"}}>
              <a
                href="/payouts?activeTab=transaction"
                style={{
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                Transaction fee settings
              </a>
            </div>
          </>
        )}
      </StyledModalContentWrapper>
    </Modal>
  );
}
